import React from 'react';
import { TableToolbar } from 'mui-datatables';
import { useTableCard } from 'UI/globalStyles/DataTableStyles';

export const Toolbar = props => {
  const tableClasses = useTableCard();

  return (
    <TableToolbar
      classes={{
        root: tableClasses.toolbar,
        actions: tableClasses.actions
      }}
      {...props}
    />
  );
};
